class managementDetailCtrl {
  constructor($scope, logger, httpRequest, $state, globalFn, $sce) {
    httpRequest.get_dictByTypeArr(['ovat_tax_rate']).then((res) => {
      $scope.ivatTaxRate = res.data.value.ovat_tax_rate
    })
    const invoiceInfo = JSON.parse($state.params.object)
    $scope.showlistflag = true
    $scope.showPdf = true
    $scope.collapse = function collapse() {
      $scope.showPdf = !$scope.showPdf
    }
    $scope.param = {}
    $scope.param.currentListPage = 1
    // 清单分页查询
    $scope.pageListChanged = function () {
      httpRequest
        .post_queryInvoiceDetail({
          pageNum: $scope.param.currentListPage,
          pageSize: 10,
          param: {
            invoiceCode: invoiceInfo.invoiceCode,
            invoiceNumber: invoiceInfo.invoiceNumber,
            invoiceType: $scope.param.invoiceType,
          },
        })
        .then((responseData) => {
          $scope.param.detail = responseData.data.value.list
          $scope.param.totalListItems = responseData.data.value.total
        })
    }

    // 隐藏一二级菜单,仅限我的工作台->详情
    if ($state.current.name === 'workspace.item.management') {
      $('#wrapper').addClass('invoiceDetailPage')
      $scope.$on('$stateChangeStart', () => {
        $('#wrapper').removeClass('invoiceDetailPage')
      })
    }

    // 获取数据
    httpRequest.get_getInvoice(invoiceInfo).then((res) => {
      if (!res.data.value) {
        return logger.logError('暂无数据')
      }
      $scope.param = res.data.value
      httpRequest
        .post_queryInvoiceDetail({
          pageNum: 1,
          pageSize: 10,
          param: {
            invoiceCode: invoiceInfo.invoiceCode,
            invoiceNumber: invoiceInfo.invoiceNumber,
            invoiceType: $scope.param.invoiceType,
          },
        })
        .then((responseData) => {
          $scope.param.detail = responseData.data.value.list
          $scope.param.totalListItems = responseData.data.value.total
        })
      httpRequest.get_getIvatFiles(invoiceInfo).then((response) => {
        $scope.param.fileInfoList = response.data.value
        if (
          $scope.param.fileInfoList &&
          $scope.param.fileInfoList.length == 1
        ) {
          $scope.param.imageKey =
            host.etcloudPdf +
            $sce.trustAsResourceUrl($scope.param.fileInfoList[0].storageKey)
          if ($scope.param.fileInfoList[0].fileType === 'pdf') {
            $scope.isPdf = true
            setTimeout(() => {
              $('#embedPdf').css('display', 'block')
            }, 10)
            const win = window.open($scope.param.imageKey)
            win.onload = () => {
              $(win.document.documentElement).prepend(
                '<head><title>影像详情</title></head>'
              )
              const timer = setInterval(() => {
                // 1
                console.log($(win.document.documentElement).find('title'))
                $(win.document.documentElement).find('title').empty()
                $(win.document.documentElement).prepend(
                  '<head><title>影像详情</title></head>'
                )
              }, 100)
              setTimeout(() => {
                clearInterval(timer)
              }, 10000)
            }
          } else {
            $scope.isPdf = false
          }
        } else {
          $scope.param.imageKey = ''
        }
      })
      $scope.isTaxText = '不含税'
      $scope.init()
      $scope.adValoremTotalChinese = globalFn.digitUppercase(
        $scope.param.adValoremTotal
      )
      // 开票点数据
      if ($scope.ukeyList != null && $scope.ukeyList.length > 0) {
        for (let i = 0, l = $scope.ukeyList.length; i < l; i++) {
          if ($scope.ukeyList[i].ukeyId === $scope.param.ukeyId) {
            $scope.param.ukeyName = $scope.ukeyList[i].ukeyName
          }
        }
      }
    })

    // 2 -- 系统初始化
    $scope.init = function () {
      if ($scope.param.isTax == '1') {
        $scope.isTaxText = '含税'
      }
    }
  }
}

managementDetailCtrl.$inject = [
  '$scope',
  'logger',
  'httpRequest',
  '$state',
  'globalFn',
  '$sce',
]
export default managementDetailCtrl



// WEBPACK FOOTER //
// ./src/app/input/inputInvoice/management/managementDetailCtrl.js